






































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Coordinate from '@/models/coordinate';

@Component({})
export default class FindByCoordinateWidget extends Vue {
    public latitude: Coordinate = new Coordinate();
    public longitude: Coordinate = new Coordinate();

    @Prop() private scale!: number;

    private find(): void {
        const latitude = (this.latitude.degree ?? 0) +
                        (this.latitude.minute ?? 0) / 60 +
                        (this.latitude.second ?? 0) / 3600;
        const longitude = (this.longitude.degree ?? 0) +
                        (this.longitude.minute ?? 0) / 60 +
                        (this.longitude.second ?? 0) / 3600;
        if (latitude > 0 && longitude > 0) {
            this.$emit('onFind', latitude, longitude, this.scale);
        }
    }
}
